import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarPlus, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PlannedTowns } from "@/components/PlannedTowns";

export const BuildPlan = () => {
  const [n, setN] = useState(8);
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const suggest = (count = n) => api.get(`/plan/suggest?count=${count}`).then((r) => setPlan(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { suggest(8); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const queue = async () => {
    const byCountry = {};
    plan.picks.forEach((p) => { (byCountry[p.country] = byCountry[p.country] || []).push(p.town); });
    if (!window.confirm(`Queue ${plan.picks.length} guides to build tonight (${Object.entries(byCountry).map(([c, t]) => `${t.length} ${c}`).join(", ")})? Each uses AI credit; shorts and Instagram posts are written automatically when each finishes.`)) return;
    setBusy(true);
    try {
      for (const [country, towns] of Object.entries(byCountry)) await api.post("/batches", { towns, country, start: "tonight" });
      toast.success("Queued for tonight's overnight build");
      suggest();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="border border-[#E2D9CC] bg-[#FAF7F2] p-6" data-testid="build-plan">
      <div className="flex flex-wrap items-end gap-4 mb-4">
        <div className="mr-auto">
          <p className="eyebrow mb-1 flex items-center gap-2"><CalendarPlus className="w-4 h-4" />Monthly build plan</p>
          <p className="text-sm text-[#8C827A]">The next towns to build, spread across the regions with the fewest guides, shortlisted towns first.{plan ? ` ${plan.regions_without_guides} regions have no guide yet.` : ""}</p>
        </div>
        <label className="text-sm">Towns <input type="number" min={1} max={30} value={n} onChange={(e) => setN(Math.max(1, Math.min(30, +e.target.value || 1)))} className="w-16 border border-[#E2D9CC] px-2 py-1 ml-1 bg-white" data-testid="build-plan-count" /></label>
        <Button variant="outline" className="rounded-none" onClick={() => suggest()} data-testid="build-plan-suggest">Suggest</Button>
        <Button className="rounded-none" onClick={queue} disabled={busy || !plan?.picks?.length} data-testid="build-plan-queue">{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Queue for tonight</Button>
      </div>
      {plan && <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">{plan.picks.map((p, i) => (
        <li key={i} className="border border-[#E2D9CC] bg-white px-3 py-2 text-sm" data-testid={`build-plan-pick-${i}`}>
          <span className="font-medium">{p.town}</span>{p.shortlisted && <span className="ml-2 text-[10px] uppercase tracking-wider text-[#C59B27]">shortlisted</span>}
          <p className="text-xs text-[#8C827A]">{p.region}, {p.country} · {p.region_guides} guide{p.region_guides === 1 ? "" : "s"} in region</p>
        </li>))}</ol>}
      <PlannedTowns />
    </section>
  );
};
